import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const ShowChartIcon = forwardRef<SVGSVGElement, IconProps>(function ShowChartIcon(
  { height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Icon/12px/Outline/Chart-show">
        <g id="Vector">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.6328 12.8105C2.42173 11.8607 2.33333 10.6244 2.33333 9C2.33333 7.37556 2.42173 6.13926 2.6328 5.18952C2.84278 4.24471 3.15658 3.6673 3.53681 3.28707C4.2782 2.54568 5.68069 2.15629 9 2.15629C12.3193 2.15629 13.7218 2.54568 14.4632 3.28707C14.8434 3.6673 15.1572 4.24471 15.3672 5.18952C15.5783 6.13926 15.6667 7.37556 15.6667 9C15.6667 10.6244 15.5783 11.8607 15.3672 12.8105C15.1572 13.7553 14.8434 14.3327 14.4632 14.7129C13.7218 15.4543 12.3193 15.8437 9 15.8437C5.68069 15.8437 4.2782 15.4543 3.53681 14.7129C3.15658 14.3327 2.84278 13.7553 2.6328 12.8105ZM9 17C2.412 17 1 15.588 1 9C1 2.412 2.412 1 9 1C15.588 1 17 2.412 17 9C17 15.588 15.588 17 9 17Z"
            fill="#534D65"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 5.08852C9.36819 5.08852 9.66667 5.34736 9.66667 5.66667V12.3333C9.66667 12.6526 9.36819 12.9115 9 12.9115C8.63181 12.9115 8.33333 12.6526 8.33333 12.3333V5.66667C8.33333 5.34736 8.63181 5.08852 9 5.08852ZM12.3333 7.75519C12.7015 7.75519 13 8.01403 13 8.33333V12.3333C13 12.6526 12.7015 12.9115 12.3333 12.9115C11.9651 12.9115 11.6667 12.6526 11.6667 12.3333V8.33333C11.6667 8.01403 11.9651 7.75519 12.3333 7.75519ZM5.66667 9.08852C6.03486 9.08852 6.33333 9.34736 6.33333 9.66667V12.3333C6.33333 12.6526 6.03486 12.9115 5.66667 12.9115C5.29848 12.9115 5 12.6526 5 12.3333V9.66667C5 9.34736 5.29848 9.08852 5.66667 9.08852Z"
            fill="#534D65"
          />
        </g>
      </g>
    </svg>
  );
});
